const colors = {
  black: '#000000',
  regalBlue: '#01526C',
  pacificBlue: '#03B0B4',
  doveGray: '#5B5B57',
  silver: '#B5B5AC',
  mercury: '#E5E4D9',
  wildSand: '#F5F5E8',
  white: '#FFFFF4',
  green: '#28a745',
  red: '#dc3545',
  aquamarine: '#8FFFE4',
};

export default colors;
